import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Icon } from '@mui/material';
import { stopProp } from '../../utils';
import { size, get } from '../../lib/lodash';
import { useScreen } from '../../styles';

const spliceAt = (arr, key, v, add) => {
  key = `${key}`.split('.');
  const ind = key.pop();
  let val;
  if (add) {
    val = get(arr, key, arr).splice(ind, v, add);
  } else {
    val = get(arr, key, arr).splice(ind, v);
  }
  return val;
}

// a little function to help us with reordering the result
const reorder = (list, res) => {
  let items = [...list];

  const { source, destination } = res;

  const sourceIndex = (() => {
    const s_levels = source.droppableId.split('_');
    if (size(s_levels) > 1) {
      return s_levels.map((s, i) => {
        if (i === 0) { return }
        return s;
      }).filter(f => f !== undefined).join('.items') + `.items.${source.index}`;
    } else {
      return source.index;
    }
  })();

  const destIndex = (() => {
    const s_levels = destination.droppableId.split('_');
    if (size(s_levels) > 1) {
      return s_levels.map((s, i) => {
        if (i === 0) { return }
        return s;
      }).filter(f => f !== undefined).join('.items') + `.items.${destination.index}`;
    } else {
      return destination.index;
    }
  })();

  const [removed] = spliceAt(items, sourceIndex, 1);
  spliceAt(items, destIndex, 0, removed);

  return items;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  position: 'relative',

  background: isDragging ? 'rgba(0,0,0,0.1)' : undefined,
  borderRadius: 5,

  ...draggableStyle,
});

const getListStyle = ({ isDraggingOver, isMobile, ...props }) => {
  const forceGrid = props.type === 'grid';
  const isRow = forceGrid || (!isMobile && !props.verticalOnly);
  return {
    display: isRow ? 'flex' : 'block',
    flexDirection: isRow ? 'row' : 'column',
    flexWrap: 'wrap',
  };
};

export const SortableList = (props) => {
  const [items, setItems] = useState(props.items);
  const { isMobile } = useScreen();

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const _items = reorder(items, result);

    props.onSort && props.onSort(_items);
  };

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={'0'} type="droppableItem">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle({ ...props, isDraggingOver: snapshot.isDraggingOver, isMobile })} onClick={size(items) ? stopProp : undefined}>
            {items.map((item, index) => <DragRow {...props} item={item} index={index} level={0} />)}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export const DragRow = props => {
  const { item, index, level } = props;
  const { isMobile } = useScreen();

  const canDrag = get(item, 'canDrag', true);

  return (
    <Draggable key={item.key} draggableId={item.key} index={index}>
      {(provided, snapshot) => (
        <div ref={provided.innerRef} {...provided.draggableProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)} onClick={stopProp}>
          <div style={{ marginLeft: 26 }}>
            {typeof item.content === 'function' ? item.content() : item.content}
            {!!item.items && <Droppable  droppableId={`${level}_${index}`}>
              {(_provided, _snapshot) => (
                <div {..._provided.droppableProps} ref={_provided.innerRef} style={getListStyle({ ...props, isDraggingOver: snapshot.isDraggingOver, isMobile })} onClick={size(item.items) ? stopProp : undefined}>
                  {!size(item.items) && <div style={{ height: 40 }} />}
                  {item.items.map((_item, _index) => <DragRow {...props} item={_item} index={_index} level={parseInt(level) + 1} />)}
                  {_provided.placeholder}
                </div>
              )}
            </Droppable>}
          </div>
          {canDrag && <div {...provided.dragHandleProps} onClick={stopProp} style={{ position: 'absolute', left: 0, top: 16 }}>
            <Icon>drag_indicator</Icon>
          </div>}
        </div>
      )}
    </Draggable>
  )
}

export default SortableList;
